import  * as InstrumentTestsConstants from './InstrumentTestsConstants';
import AppService from 'Global/AppService';

export const addDeviceToInstrumentTestsReducerState = (instanceId) => {
	return {
		type: InstrumentTestsConstants.INSTRUMENT_TESTS_DEVICE_STATE_ADD,
		payload: instanceId
	}
};

export const removeDeviceFromInstrumentTestsReducerState = (instanceId) => {
	return {
		type: InstrumentTestsConstants.INSTRUMENT_TESTS_DEVICE_STATE_REMOVE,
		payload: instanceId
	}
};

export const InstrumentTestsActions = (url, payload, instanceId) => {
    return (dispatch) => {
        dispatch({ type: InstrumentTestsConstants.INSTRUMENT_TESTS_REQUEST, payload: { instanceId, newState: payload } });
        function callback(success, err) {
            if (success.result) {
                dispatch({ type: InstrumentTestsConstants.INSTRUMENT_TESTS_SUCCESS, payload: { instanceId, newState: success.result } });
            } else {
                dispatch({ type: InstrumentTestsConstants.INSTRUMENT_TESTS_FAILURE, payload: { instanceId, newState: err.responseJSON } });
            }
        }
        AppService.postData(payload, url, callback);
    }
}
